import apiClient from "../../../services/apiClient";
import "./ResetPasswordRequest.scss";
import React, { useRef, useState } from "react";
import { toast } from "react-toastify";

const _submit = (setSent: Function, email: string) => {
  if (!email?.length) {
    toast.error("Vous devez préciser votre adresse mail.", {
      className: "toast-error",
    });
    return;
  }

  apiClient
    .post("auth/password/reset", { email })
    .then((_) => setSent(true))
    .catch((err) => {
      if (process.env.NODE_ENV !== "production") {
        console.error(err);
      }
      toast.error("Aucun compte ne correspond à cette adresse mail.", {
        className: "toast-error",
      });
    });
};

const ResetPasswordRequest = () => {
  const email = useRef() as React.MutableRefObject<HTMLInputElement>;
  const [sent, setSent] = useState(false);

  return (
    <div id="reset-password-request">
      <h2>Demande de réinitialisation de mot de passe</h2>
      {sent ? (
        <React.Fragment>
          <h3>Requête prise en compte</h3>
          <p>
            Vous allez recevoir un mail afin de procéder à la modification de
            votre mot de passe.
          </p>
        </React.Fragment>
      ) : (
        <form
          onSubmit={($event) => {
            $event.preventDefault();
            _submit(setSent, email.current.value.toLowerCase().trim());
          }}
        >
          <input
            type="email"
            name="email"
            placeholder="Votre adresse mail"
            ref={email}
            autoCapitalize="off"
            autoCorrect="off"
            tabIndex={1}
            autoFocus
          />
          <input type="submit" value="Confirmer" />
        </form>
      )}
    </div>
  );
};

export default ResetPasswordRequest;
